import { render, staticRenderFns } from "./RentalNewsView.vue?vue&type=template&id=c4d72dec"
import script from "@/scripts/rentalNews/rentalNewsView.js?vue&type=script&lang=js&external"
export * from "@/scripts/rentalNews/rentalNewsView.js?vue&type=script&lang=js&external"
import style0 from "./RentalNewsView.vue?vue&type=style&index=0&id=c4d72dec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports